module.exports = __webpack_public_path__ + "static/media/Vault Professional.ec4f3436.png";